import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/get-gallery`
        );
        setImages(res.data.gallery);
      } catch (error) {
        console.error("Error fetching gallery images:", error);
      }
    };

    fetchGallery();
  }, []);

  const handleOpen = (image) => setSelectedImage(image);
  const handleClose = () => setSelectedImage(null);

  return (
    <Box
      sx={{
        padding: "50px",
        marginTop: "100px",
        backgroundColor: "aliceblue",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h3"
        className="h3"
        sx={{ fontWeight: "bold", mb: 3 }}
      >
        Our Gallery
      </Typography>
      <Grid container spacing={4}>
        {images.map((img, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              onClick={() => handleOpen(img)}
              sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: 2,
                cursor: "pointer",
                height: "300px",
                "&:hover .hoverText": {
                  opacity: 1,
                },
              }}
            >
              <img
                src={`${process.env.REACT_APP_API_URL}/${img.image_path}`}
                alt={img.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: "8px",
                }}
              />
              <Box
                className="hoverText"
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(0,0,0,0.6)",
                  color: "white",
                  textAlign: "center",
                  opacity: 0,
                  transition: "opacity 0.3s ease-in-out",
                  p: 1,
                }}
              >
                <Typography variant="subtitle1">{img.title}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Fullscreen Image Modal */}
      <Dialog open={!!selectedImage} onClose={handleClose} maxWidth="lg">
        <DialogContent sx={{ position: "relative", p: 0 }}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 10,
              color: "white",
            }}
          >
            <CloseIcon />
          </IconButton>
          {selectedImage && (
            <img
              src={`${process.env.REACT_APP_API_URL}/${selectedImage.image_path}`}
              alt={selectedImage.title}
              style={{
                minHeight: "500px",
                minWidth: "500px",
                width: "100%",
                height: "100%",
                objectFit: "contain",
                backgroundColor: "black",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Gallery;
